import React from "react";
import {DataForPreviewDto} from "../../editor/spots/rightContent/flyerPages/FramesScreenRightPanel";
import {makeStyles} from "@mui/styles";
import {LinkPreviewPopup} from "./typesOfPopups/linkPreviewPopup";
import {Box} from "@mui/material";
import {ImagePreviewPopup} from "./typesOfPopups/imagePreviewPopup";

const useStyles = makeStyles(() => ({
    popup: {
        display: `flex`,
        maxWidth: `300px`,
        minWidth: `300px`,
        height: "300px",
        flexFlow: `row`,
    }
}))

interface Props {
    previewUrlData?: DataForPreviewDto;
}

export const PreviewUrlPopup: React.FC<Props> = ({
                                                     previewUrlData
                                                 }) => {
    const classes = useStyles();
    let popupContent: React.ReactElement;
    switch (previewUrlData?.frameType) {
        case "2":
        case "5":{
            popupContent = <ImagePreviewPopup previewUrlData={previewUrlData}/>;
            break;
        }
        case "3":
        case "4":{
            popupContent = <LinkPreviewPopup previewUrlData={previewUrlData}/>;
            break;
        }
        case "6": {
            popupContent = <ImagePreviewPopup previewUrlData={previewUrlData} is360iframe={true}/>;
            break
        }
        default : {
            popupContent = <></>;
            break;
        }
    }
    return (
        <Box className={classes.popup}>
            {popupContent}
        </Box>
    )

}